import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Options } from 'highcharts';
import { ILuminaria, IUsuario } from 'modelos/src';

import { IMongoDateToStringFormat } from 'modelosSeguridad/src';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-chart-tiempo-encendida',
  templateUrl: 'chart-tiempo-encendida.component.html',
  styleUrls: ['./chart-tiempo-encendida.component.scss'],
  standalone: false,
})
export class ChartTiempoEncendidaComponent implements OnInit, OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  // datos de ejemplo, luego reemplazas por los que te manda tu servicio
  public datos: any[];
  // Inputs
  @Input() luminarias?: ILuminaria[];
  // Outputs
  @Output() consumoUltimoMes = new EventEmitter<number>();
  // Publics
  public chart?: Options;
  public usuario?: IUsuario;
  public dateFormat: IMongoDateToStringFormat = '%Y-%m-%d';
  // Datos
  public consumo?: { fecha: string; cantidad: number };
  public eventosTotales?: number;
  public loading = false;

  constructor() {}

  private crearGrafico() {
    const conteo = {
      menos5000: 0,
      entre5000y10000: 0,
      mas10000: 0,
    };

    this.luminarias?.forEach((l) => {
      const tiempo = l.tiempoEncendida;
      if (!tiempo || tiempo < 5000) {
        conteo.menos5000++;
      } else if (tiempo <= 10000) {
        conteo.entre5000y10000++;
      } else {
        conteo.mas10000++;
      }
    });

    this.chartOptions = {
      chart: {
        type: 'bar', // horizontal
        backgroundColor: 'var(--bg-grafico)',
        style: {
          color: 'var(--fg-grafico)',
        },
        height: 300,
      },
      title: {
        text: 'Luminarias según tiempo de encendido',
        style: {
          color: 'var(--fg-grafico)',
          fontWeight: 'bold',
        },
      },
      xAxis: {
        categories: ['< 5000h', '5000-10000h', '> 10000h'],
        title: {
          text: 'Rango de horas encendidas',
          style: { color: 'var(--fg-grafico-alt)' },
        },

        labels: {
          style: {
            color: 'var(--fg-grafico)',
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          // text: 'Cantidad de luminarias',
          text: undefined,
          style: { color: 'var(--fg-grafico-alt)' },
        },
        labels: {
          style: {
            color: 'var(--fg-grafico)',
          },
        },
      },
      legend: {
        // enabled: true,
        // layout: 'horizontal',
        // align: 'center',
        // verticalAlign: 'bottom',
        itemStyle: {
          color: 'var(--p-text-color)',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{point.key}</span><br>',
        pointFormat: '<b>{point.y}</b>',
      },
      plotOptions: {
        bar: {
          // ahora plotOptions.bar en lugar de column
          dataLabels: { enabled: true },
        },
      },
      exporting: {
        enabled: false,
      },
      series: [
        {
          type: 'bar', // horizontal
          name: 'Cantidad de luminarias',
          data: [conteo.menos5000, conteo.entre5000y10000, conteo.mas10000],
          colorByPoint: true,
          colors: ['#f87171', '#fbbf24', '#34d399'], // colores por barra
        } as Highcharts.SeriesBarOptions,
      ],
      credits: { enabled: false },
    };
  }

  async ngOnInit() {
    this.loading = true;
    this.crearGrafico();
    this.loading = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['luminarias'] && this.luminarias) {
      this.crearGrafico();
    }
  }
}
